import { Injectable } from "@angular/core";

declare let gtag: Function;

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {

    public eventEmitter(
        eventName: string,
        eventCategory: string,
        eventAction: string,
        eventLabel: string = null,
        eventValue: number = null) {
            const event: any = {
                event_category: eventCategory,
                event_label: eventLabel,
                event_action: eventAction,
                value: eventValue
            };
            //console.log('event ' +  JSON.stringify(event));
            gtag('event', eventName, event);
    }

    public routeEmitter(
        id: string,
        route: string) {
            //console.log(route);
            gtag('config', id, {
                'page_path': route
            })
    }

} 